export enum FetchingStatus {
  NotStarted = 'NOT_STARTED',
  Fetching = 'FETCHING',
  Done = 'DONE',
  Error = 'ERROR',
}
